const isLoggedIn = (state) => {
  return state.isLoggedIn
}

const getToken = (state) => {
  return state.token
}

const isRefreshTokenPending = (state) => {
  return state.isRefreshTokenPending
}

export default {
  isLoggedIn,
  isRefreshTokenPending,
  getToken
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js